angular.module('qkr').factory('transService', (merchantService, $rootScope, appConfig, $http, $q) => {
    const getMerchant = function() {
        const deferred = $q.defer();

        if ($rootScope.merchantInfo != null) {
            deferred.resolve($rootScope.merchantInfo);
        } else {
            merchantService.refreshMerchantInfo().then((merchantInfo) => {
                deferred.resolve(merchantInfo);
            });
        }

        return deferred.promise;
    };

    return {
        sortSchoolTrans(transList) {
            // Go through list of transactions, sort transItems by deliverDate then beneficiaryId, set to null if already seen
            // Nicer than doing a groupBy and having to have a separate ng-repeat in the transaction list template

            angular.forEach(transList, (trans) => {
                trans.transItems.sort((a, b) => {
                    if (a.deliverDate < b.deliverDate) {
                        return -1;
                    } else if (a.deliverDate > b.deliverDate) {
                        return 1;
                    } else if (a.beneficiaryId < b.beneficiaryId) {
                            return -1;
                        } else if (a.beneficiaryId > b.beneficiaryId) {
                            return 1;
                        } else {
                            return 0;
                        }
                });

                const seenBeneficiaryDateCombos = [];
                const seenDates = [];

                angular.forEach(trans.transItems, (transItem) => {
                    let beneficiaryDateCombo = transItem.beneficiaryId;
                    if (transItem.deliverDate) {
                        beneficiaryDateCombo = transItem.deliverDate.toString() + beneficiaryDateCombo;
                    }

                    if (seenBeneficiaryDateCombos.indexOf(beneficiaryDateCombo) === -1) {
                        seenBeneficiaryDateCombos.push(beneficiaryDateCombo);
                    } else {
                        transItem.beneficiaryName = null;
                    }

                    if (seenDates.indexOf(transItem.deliverDate) === -1) {
                        seenDates.push(transItem.deliverDate);
                    } else {
                        transItem.deliverDate = null;
                    }
                });
            });
        },

        listTransactions(listParams) {
            return $http.post(appConfig.apiUrl + 'trans/listTrans', listParams)
                .then((response) => response.data);
        },

        getTransRefundHistory(transId) {
            return $http.post(appConfig.apiUrl + 'trans/getRefundHistory', {id: transId})
                .then((response) => response.data);
        },

        resolveRefundTransList(listParams) {
            const merchantPromise = getMerchant();
            const listTransactionsPromise = this.listTransactions(listParams);

            return $q.all([merchantPromise, listTransactionsPromise]).then((responses) => ({
                    transactions: responses[1].transactions,
                    totalValue: responses[1].totalValue,
                    totalRefundedValue: responses[1].totalRefundedValue,
                    totalOriginalValue: responses[1].totalOriginalValue,
                    isSchoolLike: merchantService.behaviour(responses[0], 'requiresBeneficiary'),
                    allowPartial: responses[0].contactDetails.country.isoCode !== 'CO',
                    merchant: responses[0]
                }));
        }
    };
});



// WEBPACK FOOTER //
// ./src/services/trans.service.js